import orderBy from 'lodash/orderBy';

const lowerCase = (thing) => {
  if (typeof thing === 'string') {
    return thing.toLowerCase();
  }
  return thing;
};

/**
 * Sorts an array of objects alphabetically by a given property on that object
 * NOTE: This also sorts by number 🤷‍♂️
 */
const sortAZ = (list: object[], key: string, descending = false): any[] => {
  const order = descending ? 'desc' : 'asc';

  return orderBy(list, [(item) => lowerCase(item[key])], [order]);
};

export default sortAZ;
